import { useState, useRef } from "react";
import "./ImageUpload.css";

interface ImageUploadProps {
  value?: string;
  onChange: (file: File | null) => void;
  label?: string;
}

const ImageUpload = ({
  value,
  onChange,
  label = "Upload Image",
}: ImageUploadProps) => {
  const [preview, setPreview] = useState<string>(value || "");
  const inputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      onChange(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result as string);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleRemove = () => {
    setPreview("");
    onChange(null);
    if (inputRef.current) {
      inputRef.current.value = "";
    }
  };

  return (
    <div className="image-upload">
      <label className="upload-label">{label}</label>
      {preview ? (
        <div className="image-preview">
          <img src={preview} alt="Preview" />
          <button type="button" className="remove-btn" onClick={handleRemove}>
            ✕
          </button>
        </div>
      ) : (
        <label className="upload-area">
          <input
            ref={inputRef}
            type="file"
            accept="image/*"
            onChange={handleFileChange}
            hidden
          />
          <span className="upload-icon">📷</span>
          <span className="upload-text">Click to upload image</span>
          <span className="upload-hint">PNG, JPG, GIF up to 10MB</span>
        </label>
      )}
    </div>
  );
};

export default ImageUpload;
